// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.executive-kpi-dashboard {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f9ff 50%, #f5f3ff 100%);
  min-height: 100vh;
  padding: 24px;
}

/* Executive Card Components */
.executive-kpi-card {
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.executive-kpi-card:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transform: translateY(-2px);
}

.executive-kpi-card-header {
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(to right, #f8fafc, #ffffff);
}

.executive-kpi-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.executive-kpi-card-content {
  padding: 24px;
}

/* Executive Header */
.executive-kpi-header {
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  padding: 28px;
  margin-bottom: 28px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

.executive-kpi-gradient-title {
  background: linear-gradient(135deg, #1e40af 0%, #7e22ce 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 38px;
  font-weight: 800;
  margin-bottom: 8px;
}

/* KPI Cards Grid */
.executive-kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin-bottom: 28px;
}

.executive-kpi-item {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.executive-kpi-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
}

.executive-kpi-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.executive-kpi-value {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 8px;
}

.executive-kpi-label {
  font-size: 14px;
  color: #64748b;
  line-height: 1.4;
}

/* Charts Grid */
.executive-charts-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.executive-insights-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.executive-integration-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
}

/* Button Styles */
.executive-kpi-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  font-size: 14px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.executive-kpi-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.executive-btn-success {
  background: linear-gradient(135deg, #059669, #10b981);
  color: white;
}

.executive-btn-success:hover {
  background: linear-gradient(135deg, #047857, #059669);
}

.executive-btn-primary {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: white;
}

.executive-btn-primary:hover {
  background: linear-gradient(135deg, #1d4ed8, #2563eb);
}

/* AI Insights List */
.executive-ai-insights {
  list-style: none;
  padding: 0;
  margin: 0;
}

.executive-ai-insight-item {
  background: linear-gradient(135deg, #f0f9ff, #f8fafc);
  border: 1px solid #e0f2fe;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  border-left: 4px solid #0ea5e9;
}

.executive-ai-insight-item:hover {
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.15);
}

/* Status List */
.executive-status-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.executive-status-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.executive-status-item:hover {
  background: #f1f5f9;
  transform: translateX(2px);
}

.executive-status-indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 12px;
  background: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
}

/* System Metrics */
.executive-system-metrics {
  list-style: none;
  padding: 0;
  margin: 0;
}

.executive-system-metric {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

.executive-system-metric:last-child {
  border-bottom: none;
}

.executive-metric-value {
  font-weight: 600;
  color: #1e293b;
  background: #f8fafc;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 14px;
}

/* Chart Containers */
.executive-chart-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

/* Icon Styles */
.executive-icon-badge {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: white;
  box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.3);
}

/* Color Utilities */
.executive-text-blue-700 {
  color: #1d4ed8;
}
.executive-text-green-600 {
  color: #059669;
}
.executive-text-amber-600 {
  color: #d97706;
}
.executive-text-indigo-600 {
  color: #4f46e5;
}
.executive-text-emerald-600 {
  color: #059669;
}
.executive-text-slate-600 {
  color: #475569;
}
.executive-text-slate-700 {
  color: #334155;
}
.executive-text-slate-800 {
  color: #1e293b;
}

.executive-bg-blue-50 {
  background-color: #dbeafe;
}
.executive-bg-green-50 {
  background-color: #dcfce7;
}

/* Spacing Utilities */
.executive-mb-2 {
  margin-bottom: 8px;
}
.executive-mb-3 {
  margin-bottom: 12px;
}
.executive-mb-4 {
  margin-bottom: 16px;
}
.executive-mb-6 {
  margin-bottom: 24px;
}
.executive-mt-3 {
  margin-top: 12px;
}
.executive-mt-4 {
  margin-top: 16px;
}
.executive-mr-1 {
  margin-right: 4px;
}
.executive-mr-2 {
  margin-right: 8px;
}
.executive-mr-3 {
  margin-right: 12px;
}

.executive-space-y-1 > * + * {
  margin-top: 4px;
}
.executive-space-y-3 > * + * {
  margin-top: 12px;
}
.executive-space-y-4 > * + * {
  margin-top: 16px;
}

/* Text Utilities */
.executive-text-sm {
  font-size: 14px;
}
.executive-text-lg {
  font-size: 18px;
}
.executive-text-xl {
  font-size: 20px;
}
.executive-text-2xl {
  font-size: 24px;
}
.executive-text-3xl {
  font-size: 30px;
}

.executive-font-semibold {
  font-weight: 600;
}
.executive-font-bold {
  font-weight: 700;
}
.executive-font-extrabold {
  font-weight: 800;
}

.executive-leading-relaxed {
  line-height: 1.6;
}

/* Flex Utilities */
.executive-flex {
  display: flex;
}
.executive-items-center {
  align-items: center;
}
.executive-justify-between {
  justify-content: space-between;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .executive-kpi-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .executive-charts-grid,
  .executive-insights-grid,
  .executive-integration-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .executive-kpi-dashboard {
    padding: 16px;
  }

  .executive-kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .executive-kpi-header {
    padding: 20px;
  }

  .executive-kpi-gradient-title {
    font-size: 28px;
  }
}

@media (max-width: 640px) {
  .executive-kpi-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/executive-kpi-styles.css"],"names":[],"mappings":"AAAA;EACE,mEAAmE;EACnE,0EAA0E;EAC1E,iBAAiB;EACjB,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;wCACsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;EAC9C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,kDAAkD;AACpD;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".executive-kpi-dashboard {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, sans-serif;\n  background: linear-gradient(135deg, #f8fafc 0%, #f0f9ff 50%, #f5f3ff 100%);\n  min-height: 100vh;\n  padding: 24px;\n}\n\n/* Executive Card Components */\n.executive-kpi-card {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.executive-kpi-card:hover {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  transform: translateY(-2px);\n}\n\n.executive-kpi-card-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(to right, #f8fafc, #ffffff);\n}\n\n.executive-kpi-card-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n}\n\n.executive-kpi-card-content {\n  padding: 24px;\n}\n\n/* Executive Header */\n.executive-kpi-header {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n  padding: 28px;\n  margin-bottom: 28px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.executive-kpi-gradient-title {\n  background: linear-gradient(135deg, #1e40af 0%, #7e22ce 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 38px;\n  font-weight: 800;\n  margin-bottom: 8px;\n}\n\n/* KPI Cards Grid */\n.executive-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n  margin-bottom: 28px;\n}\n\n.executive-kpi-item {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.executive-kpi-item::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6);\n}\n\n.executive-kpi-item:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n}\n\n.executive-kpi-value {\n  font-size: 28px;\n  font-weight: 800;\n  margin-bottom: 8px;\n}\n\n.executive-kpi-label {\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n/* Charts Grid */\n.executive-charts-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.executive-insights-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.executive-integration-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n}\n\n/* Button Styles */\n.executive-kpi-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  font-size: 14px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.executive-kpi-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.executive-btn-success {\n  background: linear-gradient(135deg, #059669, #10b981);\n  color: white;\n}\n\n.executive-btn-success:hover {\n  background: linear-gradient(135deg, #047857, #059669);\n}\n\n.executive-btn-primary {\n  background: linear-gradient(135deg, #2563eb, #3b82f6);\n  color: white;\n}\n\n.executive-btn-primary:hover {\n  background: linear-gradient(135deg, #1d4ed8, #2563eb);\n}\n\n/* AI Insights List */\n.executive-ai-insights {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.executive-ai-insight-item {\n  background: linear-gradient(135deg, #f0f9ff, #f8fafc);\n  border: 1px solid #e0f2fe;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 12px;\n  transition: all 0.2s ease;\n  border-left: 4px solid #0ea5e9;\n}\n\n.executive-ai-insight-item:hover {\n  transform: translateX(4px);\n  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.15);\n}\n\n/* Status List */\n.executive-status-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.executive-status-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.executive-status-item:hover {\n  background: #f1f5f9;\n  transform: translateX(2px);\n}\n\n.executive-status-indicator {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin-right: 12px;\n  background: #10b981;\n  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);\n}\n\n/* System Metrics */\n.executive-system-metrics {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.executive-system-metric {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.executive-system-metric:last-child {\n  border-bottom: none;\n}\n\n.executive-metric-value {\n  font-weight: 600;\n  color: #1e293b;\n  background: #f8fafc;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n/* Chart Containers */\n.executive-chart-container {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\n/* Icon Styles */\n.executive-icon-badge {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  background: linear-gradient(135deg, #3b82f6, #6366f1);\n  color: white;\n  box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.3);\n}\n\n/* Color Utilities */\n.executive-text-blue-700 {\n  color: #1d4ed8;\n}\n.executive-text-green-600 {\n  color: #059669;\n}\n.executive-text-amber-600 {\n  color: #d97706;\n}\n.executive-text-indigo-600 {\n  color: #4f46e5;\n}\n.executive-text-emerald-600 {\n  color: #059669;\n}\n.executive-text-slate-600 {\n  color: #475569;\n}\n.executive-text-slate-700 {\n  color: #334155;\n}\n.executive-text-slate-800 {\n  color: #1e293b;\n}\n\n.executive-bg-blue-50 {\n  background-color: #dbeafe;\n}\n.executive-bg-green-50 {\n  background-color: #dcfce7;\n}\n\n/* Spacing Utilities */\n.executive-mb-2 {\n  margin-bottom: 8px;\n}\n.executive-mb-3 {\n  margin-bottom: 12px;\n}\n.executive-mb-4 {\n  margin-bottom: 16px;\n}\n.executive-mb-6 {\n  margin-bottom: 24px;\n}\n.executive-mt-3 {\n  margin-top: 12px;\n}\n.executive-mt-4 {\n  margin-top: 16px;\n}\n.executive-mr-1 {\n  margin-right: 4px;\n}\n.executive-mr-2 {\n  margin-right: 8px;\n}\n.executive-mr-3 {\n  margin-right: 12px;\n}\n\n.executive-space-y-1 > * + * {\n  margin-top: 4px;\n}\n.executive-space-y-3 > * + * {\n  margin-top: 12px;\n}\n.executive-space-y-4 > * + * {\n  margin-top: 16px;\n}\n\n/* Text Utilities */\n.executive-text-sm {\n  font-size: 14px;\n}\n.executive-text-lg {\n  font-size: 18px;\n}\n.executive-text-xl {\n  font-size: 20px;\n}\n.executive-text-2xl {\n  font-size: 24px;\n}\n.executive-text-3xl {\n  font-size: 30px;\n}\n\n.executive-font-semibold {\n  font-weight: 600;\n}\n.executive-font-bold {\n  font-weight: 700;\n}\n.executive-font-extrabold {\n  font-weight: 800;\n}\n\n.executive-leading-relaxed {\n  line-height: 1.6;\n}\n\n/* Flex Utilities */\n.executive-flex {\n  display: flex;\n}\n.executive-items-center {\n  align-items: center;\n}\n.executive-justify-between {\n  justify-content: space-between;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .executive-kpi-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .executive-charts-grid,\n  .executive-insights-grid,\n  .executive-integration-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .executive-kpi-dashboard {\n    padding: 16px;\n  }\n\n  .executive-kpi-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .executive-kpi-header {\n    padding: 20px;\n  }\n\n  .executive-kpi-gradient-title {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 640px) {\n  .executive-kpi-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
